import { FeatureModelType } from '@teinor/erp/types/company/product/feature'
import { FeatureLangModelType } from '@teinor/erp/types/company/product/feature/featureLang'
import { ModalCreateEditMediumLoading, MediumModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'


interface ModalCEFeatureProps extends ModalEditComponentProps { }

interface ModifiedFeatureModelType extends FeatureModelType {
    featureLangs: string
}
const ModalCEFeature: React.FC<ModalCEFeatureProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { basicData } = useBasicData({ url: '/api/app/product/feature/getFeatureInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined })
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.FeatureLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const fields: FormRender<FeatureLangModelType & ModifiedFeatureModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                },
                {
                    name: 'featureLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        return (
            <ModalCreateEditMediumLoading fields={fields} url={'/api/app/product/feature/updateFeature'} translations={{ title: t('editFeature', 'Editar Característica') + ' - ' + allRowData?.['FeatureLangs.name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={data ? false : true} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/product/feature/createFeature'} translations={{
            title: t('createFeature', 'Crear característica'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCEFeature